/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_ErrorInputs */

const en_tasks_panel_error = /** @type {(inputs: Tasks_Panel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch error`)
};

const fr_tasks_panel_error = /** @type {(inputs: Tasks_Panel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur de récupération`)
};

const ms_sg2_tasks_panel_error = /** @type {(inputs: Tasks_Panel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat pengambilan`)
};

/**
* | output |
* | --- |
* | "Fetch error" |
*
* @param {Tasks_Panel_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_error = /** @type {((inputs?: Tasks_Panel_ErrorInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_ErrorInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_error(inputs)
	if (locale === "fr") return fr_tasks_panel_error(inputs)
	return ms_sg2_tasks_panel_error(inputs)
});